<template>
  <div 
    v-if="transaction != null" 
    class="row-col">
    <a 
      data-dismiss="modal" 
      class="pull-right text-muted text-lg p-a-sm m-r-sm">×</a>
    <div class="p-a b-b">
      <span class="h5 text-capitalize"> {{ isVoided ? 'Voided' : '' }} Receipt</span>
    </div>

    <div class="row-row">
      <div class="row-body">
        <div class="row-inner">

          <div class="padding">
            <div class="row">
              <div class="col-sm-12">
                <h5>{{ Currency + ' ' + transaction.receipt.total_amount }}</h5>
                <small class="block">{{ transaction.receipt.outlet.name }}</small>
                <small class="block">{{ dateReceipt }}</small>
                <small class="block">{{ transaction_no }}</small>
              </div>
            </div>
            <div class="row">
              <hr>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <small class="pull-left">Table</small>
                <br>
                <h5 
                  v-if="hasTable" 
                  class="pull-left">{{ transaction.order.table.table.name }}</h5>
                <h5 
                  v-else 
                  class="pull-left">TAKEAWAY</h5>
              </div>
              <div class="col-sm-3">
                <small class="pull-left">Pax</small>
                <br>
                <h5 
                  v-if="hasTable" 
                  class="pull-left">{{ transaction.order.table.pax }}</h5>
                <h5 v-else>N/A</h5>
              </div>
              <div class="col-sm-4">
                <small class="pull-left">Cashier</small>
                <br>
                <h5 class="pull-left">{{ transaction.receipt.cashier.name }}</h5>
              </div>
            </div>
            <div class="row">
              <hr>
            </div>

            <!-- Order products -->
            <div 
              v-for="item in transaction.order.products" 
              :key="item.id" 
              :class="{'text-muted': item.voided_by !== null}">

              <div class="row">
                <div class="col-xs-7">
                  <small>{{ getItemName(item) }}</small>
                </div>
                <div class="col-xs-2">
                  <small class="pull-right">{{ item.quantity }}x</small>
                </div>
                <div class="col-xs-3">
                  <small class="pull-right">{{ getItemPrice(item) }}</small>
                </div>
              </div>

              <!-- Modifier -->
              <div 
                v-for="modifier in item.modifiers" 
                :key="modifier.id" 
                class="row">
                <div class="col-xs-7">
                  <small class="m-l-sm">{{ getModifierName(modifier) }}</small>
                </div>
                <div class="col-xs-2">
                  <small class="pull-right">{{ modifier.quantity }}x</small>
                </div>
                <div class="col-xs-3">
                  <small class="pull-right">{{ getModifierAmount(modifier) }}</small>
                </div>
              </div>

            </div>

            <div class="row">
              <hr>
            </div>

            <!-- Total -->
            <div class="row">
              <!-- subtotal -->
              <div class="col-sm-9">
                <small class="pull-right">Subtotal</small>
              </div>
              <div class="col-sm-3">
                <small class="pull-right">{{ transaction.receipt.amount }}</small>
                <br>
              </div>

              <!-- Discount -->
              <div 
                v-for="(discount, index) in discounts" 
                :key="index">
                <div class="col-sm-9">
                  <small class="pull-right">{{ discount.name }}</small>
                </div>
                <div class="col-sm-3">
                  <small class="pull-right">{{ discount.amount }}</small>
                  <br>
                </div>
              </div>

              <!-- total after discount -->
              <div 
                v-show="discounts.length" 
                class="col-sm-9">
                <small class="pull-right">After Discount</small>
              </div>
              <div 
                v-show="discounts.length" 
                class="col-sm-3">
                <small class="pull-right">{{ total_after_discount }}</small>
                <br>
              </div>

              <!-- charges -->
              <div 
                v-for="charge in transaction.receipt.charges" 
                :key="charge.id">
                <div class="col-sm-9">
                  <small class="pull-right">{{ charge.charge.name }}</small>
                </div>
                <div class="col-sm-3">
                  <small class="pull-right">{{ charge.amount }}</small>
                </div>
              </div>

              <!-- taxes -->
              <div 
                v-for="tax in transaction.receipt.taxes" 
                :key="tax.id">
                <div class="col-sm-9">
                  <small class="pull-right">{{ tax.tax.name }}</small>
                </div>
                <div class="col-sm-3">
                  <small class="pull-right">{{ tax.amount }}</small>
                </div>
              </div>

              <!-- rounding -->
              <div class="col-sm-9">
                <small class="pull-right">Rounding</small>
              </div>
              <div class="col-sm-3">
                <small class="pull-right">{{ transaction.receipt.rounding }}</small>
                <br>
              </div>

              <!-- grandtotal -->
              <div class="col-sm-9">
                <small class="pull-right"><strong>Grand Total</strong></small>
              </div>
              <div class="col-sm-3">
                <small class="pull-right"><strong>{{ transaction.receipt.total_amount }}</strong></small>
                <br>
              </div>

              <!-- Payment -->
              <div 
                v-for="payment in transaction.receipt.payments" 
                :key="payment.id">
                <div class="col-sm-9">
                  <small class="pull-right">{{ payment.payment.name + getPaymentReference(payment) }}</small>
                </div>
                <div class="col-sm-3">
                  <small class="pull-right">{{ payment.amount }}</small>
                  <br>
                </div>
              </div>

              <!-- Change -->
              <div class="col-sm-9">
                <small class="pull-right">Change</small>
              </div>
              <div class="col-sm-3">
                <small class="pull-right">{{ transaction.receipt.payments[0].change }}</small>
                <br>
              </div>
            </div>

            <div class="row">
              <!-- show voided info -->
              <div 
                v-if="isVoided" 
                class="col-sm-12 voided-box text-center">
                <small class="block">{{ transaction.receipt.void_remarks }}</small>
                <small><i>Voided by {{ transaction.receipt.voided_staff.name }} on {{ getVoidedDate(transaction.receipt) }}</i></small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <div class="p-a b-t">
      <div class="text-right">
        <button 
          class="md-btn md-raised w-xs white" 
          data-dismiss="modal">Close</button>
      </div>
    </div>
  </div><!-- root -->
</template>
<style scoped>
.voided-box {
    border: 1px dashed #666;
    border-radius: 5px;
    padding: 10px 20px;
    margin-top: 30px;
}
</style>
<script>
import numeral from 'numeral';
numeral.defaultFormat('0,0.00');

export default {
    props: {
        transaction: {
            type: Object,
            default: null,
        },
        Currency: {
            type: String,
            default: 'RM',
        },
    },

    data() {
        return {
            total_discount: 0,
        };
    },

    computed: {
        transaction_no() {
            return (
                this.transaction.receipt.sequence_number +
                '/' +
                this.transaction.receipt.receipt_number.substr(0, 8)
            );
        },

        dateReceipt() {
            return moment(this.transaction.receipt.settled_date).format(
                'Do MMMM YYYY, h:mm:ss a',
            );
        },
        isVoided() {
            return this.transaction.receipt.voided_by != null;
        },

        discounts() {
            return this.getDiscounts();
        },

        total_after_discount() {
            return numeral(
                parseFloat(this.transaction.receipt.amount) +
                    this.total_discount,
            ).format();
        },

        hasTable() {
            return this.transaction.order.table !== null;
        },
    },

    watch: {
        transaction() {
            this.resetValue();
        },
    },

    methods: {
        getItemPrice(product) {
            if (!_.isNull(product.variable_price)) {
                return product.variable_price;
            }

            if (!_.isNull(product.variant_price)) {
                return product.variant_price;
            }

            if (!_.isNull(product.unit_price)) {
                return product.unit_price;
            }

            return null;
        },

        getItemName(product) {
            if (product.variant !== null) {
                return product.name + ' (' + product.variant.name + ')';
            } else {
                return product.name;
            }
        },

        getPaymentReference(payment) {
            if (payment.payment.require_reference) {
                return !_.isEmpty(payment.reference_number)
                    ? '(' + payment.reference_number + ')'
                    : '';
            }
            return '';
        },

        getVoidedDate(receipt) {
            if (receipt.voided_by == null) return '';
            return moment(receipt.voided_at).format('Do MMMM YYYY, h:mm:ss a');
        },

        getPercentageValueFormat(discount_percentage) {
            let amount = discount_percentage.replace(/(\.[0-9]*?)0+$/, '$1');
            amount = amount.replace(/\.$/, '') + '%';
            return amount;
        },

        getModifierName(modifier) {
            if (modifier.modifier_id != null) {
                return modifier.modifier.name;
            } else {
                return modifier.name;
            }
        },

        getModifierAmount(modifier) {
            let orderModifier;
            let amount;

            // get modifier mode from modifier record
            if (modifier.modifier_id != null) {
                orderModifier = modifier.modifier;
            } else {
                // get mode from custom modifier created in central
                orderModifier = modifier;
            }

            let totalAmount = numeral(
                modifier.amount * modifier.quantity,
            ).format();

            switch (orderModifier.mode) {
                case 1:
                    amount = '+ ' + totalAmount;
                    break;
                case 2:
                case 3:
                    amount = '- ' + totalAmount;
                    break;
                default:
                    amount = totalAmount;
            }

            return amount;
        },

        getDiscounts() {
            let receipt_discounts = this.transaction.receipt.discounts;

            return receipt_discounts.map(obj => {
                let name =
                    obj.discount == null
                        ? obj.name
                            ? obj.name
                            : obj.remarks
                        : obj.discount.name;
                let discount_amout = parseFloat(obj.amount);

                this.total_discount += discount_amout;

                return {
                    name: name,
                    amount: obj.amount,
                };
            });
        },

        resetValue() {
            this.total_discount = 0;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/transaction/side_receipt.vue